import { useToast } from '@sketch/toasts'

import { useRegisterCommandBarCommands } from '@sketch/modules-common'
import { useNavigateToFrame } from '../../canvas/hooks/useNavigateToFrame'
import {
  useInspectorContext,
  useInspectorSelectedElement,
} from '../FrameView/hooks/inspector'
import { useExportModal } from '../FrameView/components/FrameDetailInspector/sections/Exports/ExportModal'
import { createInspectCommands } from './createInspectCommands'
import {
  useCreateLayerLink,
  useShouldEnableCopyLinkToLayer,
} from '../../canvas/components/LayersTree/useCreateLayerLink'

export const InspectCommandBarRegistration = () => {
  const { sketchSceneRootElement } = useInspectorContext()
  const selectedElement = useInspectorSelectedElement()
  const { openExportModal } = useExportModal()
  const { showToast } = useToast()
  const createLayerLink = useCreateLayerLink()
  const shouldEnableCopyLink = useShouldEnableCopyLinkToLayer()
  const navigateToFrame = useNavigateToFrame()

  useRegisterCommandBarCommands(
    'inspect',
    () =>
      createInspectCommands({
        navigateToFrame,
        openExportModal,
        selectedElement,
        showToast,
        sketchSceneRootElement,
        createLayerLink,
        shouldEnableCopyLink,
      }),
    [selectedElement, shouldEnableCopyLink, sketchSceneRootElement?.elementUUID]
  )

  return null
}
